module.exports = __webpack_public_path__ + "img/boy_2.4eb4c276.svg";